import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Es digital o físico?',
  a: 'Es 100% digital (PDF). Acceso inmediato en tu celular o tablet apenas realizas el pago.'
}, {
  q: '¿Necesito cocinar mucho?',
  a: 'No. Todas las recetas están diseñadas para estar listas en 15 minutos o menos, pensando en mujeres ocupadas.'
}, {
  q: '¿Funciona si tengo Hashimoto?',
  a: 'Sí, el protocolo es estrictamente antiinflamatorio, ideal para apoyar el cuerpo en condiciones autoinmunes como Hashimoto.'
}, {
  q: '¿Puedo pagar en mi moneda?',
  a: 'Sí, la plataforma convierte automáticamente el precio a tu moneda local al realizar el pago.'
}, {
  q: '¿Los ingredientes son caros o difíciles de conseguir?',
  a: 'Para nada. El Bonus 2 te enseña exactamente cómo usar ingredientes locales y económicos que encuentras en cualquier mercado de Latinoamérica.'
}, {
  q: '¿Tengo que dejar de comer carbohidratos?',
  a: 'No. Aprenderás a elegir los carbohidratos correctos que no inflaman tu tiroides, sin pasar hambre ni hacer dietas extremas.'
}, {
  q: '¿En cuánto tiempo veré resultados?',
  a: 'Muchas mujeres reportan mayor energía y menor hinchazón en la primera semana, especialmente si siguen el Acelerador de 21 Días.'
}, {
  q: '¿Es seguro si tomo levotiroxina u otros medicamentos?',
  a: 'Sí, este es un protocolo nutricional que complementa tu tratamiento médico. Nunca recomendamos dejar tu medicación sin consultar a tu doctor.'
}, {
  q: '¿Qué pasa si no me funciona?',
  a: 'Tienes 14 días de garantía total. Si no sientes cambios en tu energía o digestión, te devolvemos el 100% de tu dinero.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con un enlace seguro para descargar todos los manuales y bonos en tu dispositivo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-43">
      <div className="max-w-2xl mx-auto" data-id="element-44">
        <div className="text-center mb-6" data-id="element-45">
          <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-forest" data-id="element-46">
            ❓ Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-2" data-id="element-47">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-brand-border rounded-lg overflow-hidden" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3 text-left flex justify-between items-center bg-white" data-id="element-49">
                <span className="font-bold text-brand-forest text-sm" data-id="element-50">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-forest transition-transform duration-200 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-51" />
              </button>

              {openIndex === i && <div className="px-4 pb-3 pt-0 text-sm text-brand-text" data-id="element-52">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}